import FJModal from '@src/components/FJModals/FJModal';
import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import FJShareView from '@src/components/FJModals/FJShareModal/FJShareView.tsx';
import { FJModalsAction } from '@src/redux/action/FJModalsAction.ts';

const FJShareModal = () => {
    const dispatch = useAppDispatch();
    const isShow = useAppSelector(state => state.share.isShow);
    const isShowAddAccountPanel = useAppSelector(state => state.share.isShowAddAccountPanel);

    const onClose = () => {
        dispatch(FJModalsAction.hideShareModalAction('close'));
    };

    return (
        <FJModal width={1140} borderRadius={20} visible={isShow} backgroundColor={'transparent'} boxShadow={'none'}>
            <FJShareView onClose={onClose} isHideClose={isShowAddAccountPanel} />
        </FJModal>
    );
};

export default FJShareModal;
